<!-- eslint-disable -->
<template>
  <CommonPages id="categories" :class="['categories']" titlePrefix="Category"
    :metaDescription="pageDescription">
    <div class="categories-container">
      <!-- 顶部标题区域 -->
      <div class="categories-header" :class="[deviceType]">
        <div class="categories-title">Explore Baby Names by Category</div>
        <div class="categories-subtitle">Discover names organized by style, sound, meaning, and
          more.</div>
      </div>

      <!-- 分类卡片区域 -->
      <div class="categories-cards" :class="[deviceType]">
        <template v-for="(section, sectionIndex) in categories">
          <div class="category-card" :key="sectionIndex">
            <div class="card-header">
              <div class="card-icon">
                <div class="icon-bg"></div>
              </div>
              <div class="card-title">{{ section.title }}</div>
            </div>
            <div class="card-items">
              <router-link v-for="(item, itemIndex) in section.items" :key="itemIndex"
                :to="getCategoryPath(section.title, item.title)" tag="div" class="card-item"
                :class="item.title">
                <div class="item-text">{{ item.title }}</div>
                <img src="@/assets/default/arrow-right-small.svg" alt="arrow" class="item-arrow" />
              </router-link>
            </div>
            <router-link :to="getCategoryPath(section.title)" tag="div" class="card-footer">
              <div class="view-all">View All</div>
              <img src="@/assets/default/arrow-right-small.svg" alt="arrow" class="footer-arrow" />
            </router-link>
          </div>
          <AdComponent v-if="deviceType === 'mobile' && sectionIndex === 0" :key="'ads-category-1'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_1"
            ref="ads-category-1" class="ad-width-100 " :ads="adsensConfig?.categories_1"
            :showDebug="showDebug" />
        </template>
      </div>

    </div>

    <AdComponent :key="'ads-category-2'" v-if="deviceType === 'mobile'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_2"
      ref="ads-category-2" class="ad-width-100 pc_padding m_padding"
      :ads="adsensConfig?.categories_2" :showDebug="showDebug" />
    <AdComponent :key="'ads-category-1'" v-if="deviceType !== 'mobile'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_1"
      ref="ads-category-1" class="ad-width-100 pc_padding m_padding"
      :ads="adsensConfig?.categories_1" :showDebug="showDebug" />

    <!-- 组合模块 -->
    <div class="combinations-section" :class="[deviceType]" v-if="combinations.length > 0">
      <div class="section-header">
        <div class="section-title">Combinations</div>
      </div>
      <div class="combinations-container">
        <div class="combination-row" :class="[deviceType]">
          <div class="combination-card-link" v-for="(combo, index) in combinations" :key="index"
            @click="navigateTo(combo.url)" @mouseenter="hoveredCombination = index"
            @mouseleave="hoveredCombination = null">
            <div class="combination-card" :class="{'hovered': hoveredCombination === index}">
              <div class="combination-text">
                {{ combo.title }}
              </div>
              <div class="see-more-button">
                <span>See More</span>
                <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow"
                  class="arrow-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AdComponent v-if="deviceType === 'mobile' " :key="'ads-category-3'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_3"
      ref="ads-category-3" class="ad-width-100 m_padding" :ads="adsensConfig?.categories_3"
      :showDebug="showDebug" />

    <section class="search-sec-row" :class="[deviceType]">
      <!-- 搜索过滤区域 -->
      <div class="section-header" :class="[deviceType]">
        <div class="section-title">Search by Filter</div>
      </div>

      <div class="names-filter" :class="[deviceType]">
        <SearchFilter />
      </div>
    </section>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import SearchFilter from '@/components/SearchFilter.vue';
import AdComponent from '@/pages/components/AdComponent.vue'

// import '@/css/categories.scss';
import '@/css/common.scss';

export default {
  name: 'Categories',
  components: {
    CommonPages,
    SearchFilter,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      hoveredCombination: null,
      combinations: [],
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'showDebug',
      'deviceType',
      'domainConfig',
      'gender',
      'style',
      'meaning'
    ]),
    pageTitle () {
      return 'Categories - Filter by Style, Gender, and More';
    },
    pageDescription () {
      const origin = this.domainConfig?.origin || '';
      return `View all filters and categories to help you find the perfect ${origin} name. Sort by gender, style, syllables, and more.`;
    },
    categories () {
      const result = [];
      if (this.gender && this.gender.length > 0) {
        result.push({
          title: 'Name by Gender',
          icon: require('@/assets/icons/gender.svg'),
          items: this.gender.slice(0, 3).map(i => ({ title: i }))
        });
      }
      if (this.style && this.style.length > 0) {
        result.push({
          title: 'Name by Style',
          icon: require('@/assets/icons/style.svg'),
          items: this.style.slice(0, 3).map(i => ({ title: i }))
        });
      }
      if (this.meaning && this.meaning.length > 0) {
        result.push({
          title: 'Name by Meaning',
          icon: require('@/assets/icons/meaning.svg'),
          items: this.meaning.slice(0, 3).map(i => ({ title: i }))
        });
      }
      return result;
    }
  },
  async mounted () {
    this.fetchCombinations();
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  },
  methods: {
    getCategoryPath (sectionTitle, itemTitle = null) {
      let categoryType = '';
      switch (sectionTitle) {
        case 'Name by Gender':
          categoryType = 'gender';
          break;
        case 'Name by Style':
          categoryType = 'style';
          break;
        case 'Name by Meaning':
          categoryType = 'meaning';
          break;
        default:
          categoryType = 'general';
      }

      if (itemTitle) {
        const formattedValue = itemTitle.toLowerCase();
        return `/categories/${categoryType}/${formattedValue}`;
      } else {
        return `/categories/${categoryType}`;
      }
    },
    async fetchCombinations () {
      const origin = this.domainConfig?.origin || '';
      try {
        const params = { origin };
        const response = await this.$global.server.postAPI({
          method: 'get',
          params,
          url: '/name/combinations',
        });
        if (response.data && response.data.combinations) {
          this.combinations = response.data.combinations.slice(0, 4);
        }
      } catch (error) {
        console.error('Error fetching combinations:', error);
        this.combinations = [];
      }
    },
    navigateTo (url) {
      if (url) {
        this.$router.push(url);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.categories {
	background: #000;

	.categories-container {
		padding: rem(80) rem(180) rem(40);
		background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 1) 100%), linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
	}

	.categories-header {
		text-align: center;
		color: #fff;
		margin-bottom: rem(40);

		.categories-title {
			font-size: rem(52);
			font-weight: 900;
			line-height: rem(60);
			color: #fff;
		}

		.categories-subtitle {
			font-size: rem(20);
			line-height: rem(28);
		}
	}

	.categories-cards {
		display: flex;
		gap: rem(24);

		.category-card {
			background: #000;
			border-radius: rem(16);
			padding: rem(24);
			flex: 1;
			display: flex;
			flex-direction: column;
			gap: rem(20);

			.card-header {
				display: flex;
				align-items: center;
				gap: rem(12);

				.card-icon {
					position: relative;

					.icon-bg {
						width: rem(8);
						height: rem(8);
						flex-shrink: 0;
						aspect-ratio: 1 / 1;
						background: #fff;
						border-radius: 50%;
					}

					.icon-img {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						width: rem(20);
						height: rem(20);
					}
				}

				.card-title {
					color: #fff;
					font-size: rem(16);
					font-weight: 500;
				}
			}

			.card-items {
				display: flex;
				flex-direction: column;
				gap: rem(8);

				.card-item {
					border-radius: rem(16);
					padding: rem(18) rem(24);
					display: flex;
					justify-content: space-between;
					align-items: center;
					cursor: pointer;
					text-decoration: none;
					transition: all 0.3s ease;
					background: rgba(255, 255, 255, 0.1);
					&.Boy {
						background: var(--Linear, linear-gradient(180deg, #08f 0%, rgba(0, 136, 255, 0.2) 100%));
					}
					&.Girl {
						background: var(--Linear, linear-gradient(180deg, #e54cba 0%, rgba(229, 76, 186, 0.2) 100%));
					}
					&.Unisex {
						background: var(--Linear, linear-gradient(180deg, #c8ad17 0%, rgba(200, 173, 23, 0.2) 100%));
					}

					.item-text {
						color: #fff;
						font-size: rem(18);
						font-weight: 700;
					}

					.item-arrow {
						width: rem(6);
						height: rem(12);
						filter: brightness(0) invert(1);
					}

					&:hover {
						background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%) !important;
					}
				}
			}

			.card-footer {
				background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
				border-radius: rem(8);
				padding: rem(8) rem(16);
				display: flex;
				align-items: center;
				justify-content: center;
				gap: rem(8);
				cursor: pointer;
				width: rem(100);
				box-sizing: border-box;
				margin-top: auto;

				.view-all {
					color: #fff;
					font-size: rem(12);
					font-weight: 700;
				}

				.footer-arrow {
					width: rem(6);
					height: rem(10);
					filter: brightness(0) invert(1);
				}
			}
		}
	}

	.combinations-section {
		padding: rem(40) rem(180) rem(80) rem(180);

		.section-header {
			margin-bottom: rem(24);

			.section-title {
				color: #fff;
				font-size: rem(24);
				font-weight: 900;
			}
		}

		.combinations-container {
			.combination-row {
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				gap: rem(24);
			}

			.combination-card-link {
				text-decoration: none;
				padding: rem(2);
				border-radius: rem(16);
				background: transparent;
				transition: all 0.3s ease;
				&:hover {
					background: linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
				}
			}

			.combination-card {
				background: rgb(26, 26, 26);
				border-radius: rem(14);
				padding: rem(24);
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				height: rem(172);
				box-sizing: border-box;
				cursor: pointer;

				.combination-text {
					color: #ffffff;
					font-size: rem(18);
					line-height: rem(24);
					font-weight: 700;
				}

				.see-more-button {
					background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
					border-radius: rem(8);
					padding: rem(8) rem(16);
					display: flex;
					align-items: center;
					justify-content: center;
					gap: rem(8);
					width: rem(100);
					height: rem(28);
					box-sizing: border-box;

					span {
						color: #ffffff;
						font-size: rem(12);
						font-weight: 700;
					}

					.arrow-icon {
						width: rem(6);
						height: rem(10);
						filter: brightness(0) invert(1);
					}
				}
			}
		}
	}

	.search-sec-row {
		padding: 0 rem(180) rem(80);

		.section-header {
			margin-bottom: rem(24);

			.section-title {
				color: #fff;
				font-size: rem(24);
				font-weight: 900;
			}
		}
	}

	&.detect_deviece_mobile {
		.categories-container {
			padding: rem(40) rem(16);
		}

		.categories-header {
			.categories-title {
				font-size: rem(52);
				line-height: rem(60);
				text-align: left;
				margin-bottom: rem(16);
			}

			.categories-subtitle {
				font-size: rem(16);
				line-height: rem(24);
				text-align: left;
			}
		}

		.categories-cards {
			flex-direction: column;
		}

		.combinations-section {
			padding: rem(40) rem(16);
			.combinations-container .combination-row {
				display: flex;
				overflow-x: auto;
				gap: rem(16);
				padding: 0 rem(16);
				margin: 0 rem(-16);
				&::-webkit-scrollbar {
					display: none;
				}
				-ms-overflow-style: none;
				scrollbar-width: none;
			}
			.combination-card-link {
				flex-shrink: 0;
				width: rem(280);
			}
		}

		.search-sec-row {
			padding: 0 rem(16) rem(40);
		}

		.categories-cards .category-card .card-footer {
			width: 100%;
			border-radius: rem(12);
			padding: rem(16);

			.view-all {
				font-size: rem(14);
				font-style: normal;
				font-weight: 700;
				line-height: rem(14); /* 100% */
				text-transform: capitalize;
			}
		}
	}
}
</style> 